module.exports = __webpack_public_path__ + "cancellara-dist/img/confindustria-vicenza.2d8d63db.png";